import type { ChangeEvent, FC } from 'react';

import { Button } from '@wwe-portal/ui/components/button';
import {
  Dialog,
  CommonDialogLayout,
  EnterCodeDialogHead,
} from '@wwe-portal/ui/components/dialog';
import { Input } from '@wwe-portal/ui/components/input';

interface ExchangeCodeDialogProps {
  value: string;
  onClose?: () => void;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onSubmit?: () => void;
  isSubmitting: boolean;
  open?: boolean;
}
export const ExchangeCodeDialog: FC<ExchangeCodeDialogProps> = ({
  value,
  onClose,
  onChange,
  onSubmit,
  isSubmitting,
  open = true,
}) => {
  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose?.();
      }}
      open={open}
    >
      <CommonDialogLayout
        actionElement={
          <div className="flex justify-center">
            <Button
              className="h-[56px] w-[138px]"
              disabled={!value}
              loading={isSubmitting}
              onClick={onSubmit}
              variant="blue"
            >
              SUBMIT
            </Button>
          </div>
        }
        closable
        contentClass="w-[292px] h-[443px] px-[60px] rounded-5"
        dataId="redeem-code-dialog"
        descriptionElement={
          <div className="my-4">
            <Input
              className="rounded-none"
              hideIcon
              onChange={onChange}
              placeholder="Enter the code"
              value={value}
            />
          </div>
        }
        imageElement={<EnterCodeDialogHead />}
        layoutClass="px-0 2xl:px-0"
        onClose={onClose}
        titleElement={<div className="mt-6">Enter the Code</div>}
      />
    </Dialog>
  );
};
